module.exports = __webpack_public_path__ + "static/media/textbox_check.269b4540.svg";